const MAX_SAMPLES = 30;
const positions: { x: number; y: number }[] = [];

if (typeof window !== 'undefined') {
  window.addEventListener(
    'click',
    (e) => {
      positions.push({ x: e.clientX, y: e.clientY });
      if (positions.length > MAX_SAMPLES) positions.shift();
    },
    { passive: true },
  );
}

function stddev(arr: number[]): number {
  const n = arr.length;
  if (n < 2) return 0;
  const mean = arr.reduce((a, b) => a + b, 0) / n;
  const v = arr.reduce((a, b) => a + (b - mean) ** 2, 0) / n;
  return Math.sqrt(v);
}

export function getClickStats(): { samples: number; positionStdDev?: number } {
  if (positions.length < 2) return { samples: positions.length };
  const xs = positions.map((p) => p.x);
  const ys = positions.map((p) => p.y);
  const combined = Math.sqrt(stddev(xs) ** 2 + stddev(ys) ** 2);
  return {
    samples: positions.length,
    positionStdDev: Number(combined.toFixed(2)),
  };
}
